// Modules
import { UseFormRegisterReturn } from "react-hook-form"

// Components
import { InputContainer, ModalInput } from "~styled/input"

export interface InputProps {
  name?: string
  type?: string
  label?: string
  disabled?: boolean
  infoCopy?: string
  register?: UseFormRegisterReturn<string>
  className?: string
  placeholder?: string
  autoComplete?: "on" | "none"
  errorMessage?: string
  onChange?: () => void
  min?: number | string
  max?: number | string
  defaultValue?: string | number
}

const Input = (props: InputProps) => {
  const {
    name,
    type = "text",
    label,
    disabled,
    infoCopy,
    register,
    className,
    placeholder,
    autoComplete = "none",
    errorMessage,
    onChange,
    min,
    max,
    defaultValue,
  } = props

  return (
    <InputContainer className={className}>
      <span className="label">{label}</span>

      <ModalInput
        {...register}
        name={name || register?.name}
        type={type}
        disabled={disabled}
        onChange={(e) => {
          register?.onChange(e)
          onChange?.()
        }}
        className={errorMessage && "error"}
        placeholder={placeholder}
        autoComplete={autoComplete}
        min={min}
        max={max}
        defaultValue={defaultValue}
      />

      <span className={errorMessage ? "error-message" : "info-copy"}>
        {errorMessage || infoCopy}
      </span>
    </InputContainer>
  )
}

export default Input
